// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1y8pK","productName":"Table_productName__11ywr"};